export const PREFIX_VIRTUAL_ACCOUNT_BCI = '7770';
export const PREFIX_VIRTUAL_ACCOUNT_SANTANDER = '710';
export const PREFIX_VIRTUAL_ACCOUNT_RIPLEY = '404';
export const VIRTUAL_ACCOUNTS_PREFIXS = [PREFIX_VIRTUAL_ACCOUNT_BCI, PREFIX_VIRTUAL_ACCOUNT_SANTANDER, PREFIX_VIRTUAL_ACCOUNT_RIPLEY];
